<template>
  <slot></slot>

  <BaseDiver />

  <div
    v-tooltip.bottom="disabledReason"
    class="w-fit mt-2"
  >
    <Button
      label="Разделить"
      :disabled="disabled"
      :loading="!!disabledReason"
      @click="onDivideClick"
    />
  </div>
</template>

<script setup lang="ts">
import { BaseDiver } from '@/shared'
import Button from 'primevue/button'

defineProps<{
  disabledReason: string | null
  onDivideClick: () => void
  disabled: boolean
}>()
</script>
